import * as React from 'react';
import { Box, SvgIcon } from '@mui/material';

export function ErrorWrapper({ icon, children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <SvgIcon
        sx={{
          width: 300,
          height: 'auto',
        }}
        component={icon}
        inheritViewBox
      />
      {children}
    </Box>
  );
}
